// SEND_EMAIL_TEMPLATE serialize — maps the email-template form shape to the API
// emailTemplateData record, plus the optional sub-company recipients addition (mode + role).
// Extracted from LoanActionTransformations.utils.js to keep that file within the max-lines budget.

import { getConditionalObject } from 'utils/data';

import { replaceBracketsWithSpan } from './LoanActionsGroup.utils';
import { getContactApiFormatFromFormFormat } from './LoanActionTransformationHelpers.utils';
import { getSubCompanyRecipientsApiFormat } from './LoanActionTransformations.subCompany';

export const getSendEmailTemplateApiFormat = ({ formItem, common, dynamicFieldsOptions }) => {
  const {
    sender,
    receivers,
    ccList,
    bccList,
    templateId,
    subject,
    trackingStatus,
    subCompanyRecipients,
  } = formItem.sendEmailTemplate[0];
  const formattedSender = getContactApiFormatFromFormFormat(sender) ?? {};
  const formattedReceivers = receivers?.map(getContactApiFormatFromFormFormat) ?? [];
  const formattedCCList = ccList?.map(getContactApiFormatFromFormFormat) ?? [];
  const formattedBCCList = bccList?.map(getContactApiFormatFromFormFormat) ?? [];
  const formattedSubject = replaceBracketsWithSpan(subject, dynamicFieldsOptions);
  const subCompanyRecipientsPayload = getSubCompanyRecipientsApiFormat(subCompanyRecipients);

  return {
    ...common,
    emailTemplateData: {
      subject: formattedSubject,
      trackingStatus,
      templateCategoryId: templateId?.categoryId || null,
      templateId: templateId?.id || null,
      sender: formattedSender,
      receivers: formattedReceivers,
      ccList: formattedCCList,
      bccList: formattedBCCList,
    },
    ...getConditionalObject(!!subCompanyRecipientsPayload, () => ({
      subCompanyRecipients: subCompanyRecipientsPayload,
    })),
  };
};
